export const moneyFormatterUtility = (number) => {
    return new Intl.NumberFormat("fa-IR", {
        style: "decimal",
        currency: "IRR",
        // @ts-expect-error numberingSystem is valid option
        numberingSystem: "latn",
    }).format(number);
};
